export default __webpack_public_path__ + "static/media/bestbuy-logo.c8607e23.png";